module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAAABCAYAAACv43fXAAAAAXNSR0IArs4c6QAAABpJREFUOBFj/P//fyLDKBgNgdEQGA2BERgCANzSA2CH61ZmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/progressBar.png
// module id = zDCp
// module chunks = 1